import type { CSSProperties } from 'react';
import classnames from 'classnames';
import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import { Field } from '../elements/Field';
import { FormContextConsumer } from '../elements/formContext';

interface IRadioInputProps {
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    italicLabel?: boolean;
    label: string | JSX.Element;
    labelStyle?: CSSProperties;
    name: string;
    onChange?: (value: string) => void;
    onDoValidate?: () => void;
    onValue: string;
    radioButtonsStacked?: boolean;
    value: string | null;
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function RadioInput(props: FormContextProps<IRadioInputProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => {
                const labelClassName = classnames(props.className || '', 'custom-control custom-radio', {
                    disabled: properties.disabled,
                });
                const radioLabelClassName = classnames(
                    'custom-control-description',
                    properties.italicLabel ? 'font-style-italic' : ''
                );

                return (
                    <div
                        className={props.radioButtonsStacked ? 'form-check' : 'form-check-inline'}
                        style={properties.labelStyle}
                    >
                        <label
                            className={labelClassName}
                            data-dd-privacy="allow"
                            style={properties.labelStyle}
                        >
                            <input
                                checked={properties.value === properties.onValue}
                                className="custom-control-input"
                                disabled={properties.disabled}
                                name={properties.name}
                                onChange={async () => {
                                    if (properties.onChange) {
                                        await properties.onChange(properties.onValue);
                                    }
                                    if (properties.onDoValidate) {
                                        await properties.onDoValidate();
                                    }
                                }}
                                type="radio"
                                value={properties.onValue}
                            />
                            <span className="custom-control-indicator"></span>
                            <span
                                className={radioLabelClassName}
                                style={properties.labelStyle}
                            >
                                {properties.label || ''}
                            </span>
                            {props.children}
                        </label>
                    </div>
                );
            }}
        </FormContextConsumer>
    );
}

export function RadioField(props: FormContextProps<IRadioInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <RadioInput {...props} />
        </Field>
    );
}
